import React from 'react';
import { IMaskInput } from 'react-imask';

interface PhoneMaskInputProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

/**
 * MUI-compatible masked input for US phone numbers.
 *
 * Used via TextField's `InputProps.inputComponent` prop:
 *   <TextField InputProps={{ inputComponent: PhoneMaskInput as any }} />
 *
 * Mask: `(#00) 000-0000` where `#` is restricted to digits 2-9 (NANP rule
 * — first digit of area code can't be 0 or 1). Subsequent digits accept 0-9.
 *
 * Handles cursor management, separator auto-insertion, backspace/delete past
 * separators, paste reformatting, and selection-range deletes internally.
 * Caller only needs `value`, `onChange`, and (optionally) `inputRef`.
 */
export const PhoneMaskInput = React.forwardRef<HTMLInputElement, PhoneMaskInputProps>(
  function PhoneMaskInput(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="(#00) 000-0000"
        definitions={{ '#': /[2-9]/ }}
        inputRef={ref}
        onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
        overwrite
      />
    );
  },
);
